<mat-select #chartSelect [tabIndex]="tabIndex" [formControl]="selectCtrl" [compareWith]="compareWith"
    (selectionChange)="onSelectionChange()" [multiple]="multiple" [placeholder]="'CX.SLA_TARGET_FOR' | translate"
    (openedChange)="openedChange($event)">

    <mat-option *ngFor="let chart of charts" [value]="chart.key">
        {{ chart.value }}
    </mat-option>
</mat-select>

<mat-progress-spinner *ngIf="loading === true" diameter="16" mode="indeterminate"></mat-progress-spinner>